import request from '../libs/request'
import {getApiUrl, getReadIdCardUrl} from '../config'
import { getRandowStr, toast } from '../libs/utils'
// 获取验证码
export function getCodeImg () {
  let randomStr = getRandowStr(10)
  return {
    randomStr,
    imgUrl: `${getApiUrl()}/uac/code/${randomStr}`
  }
}

// 用户登录
export async function accountLogin (params) {
  let user = await request.post(`/uac/aut/login?mobile=${params.mobile}&code=${params.code}`, params)
  if (user && user.code && user.code.toString() === '200' && user.result.id) {
    return user.result
  }
  throw Error(user.message || '登录异常')
}
// 用户退出登录
export async function logout () {
  let user = await request.post('/uac/aut/logout', {})
  if (user && user.code && user.code.toString() === '200') {
    return true
  } else {
    toast({msg: user.message || '退出登录异常'})
  }
}
// 获取用户信息
export async function getAuthUserInfo () {
  let data = await request.post('/uac/aut/queryUserInfo', {}, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '获取用户信息异常')
}
// 修改密码
export async function updatePwd (params) {
  let data = await request.post('/uac/aut/updatePassword', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '修改密码异常'})
  }
}
// 读取身份征信
export async function readIdCardNo () {
  let data = await request.jsonp(getReadIdCardUrl(), {}, 'getIdCardData')
  if (data && data.name) {
    return data
  } else {
    toast({msg: data.message || '读取患者身份证信息异常'})
  }
}
// 查询通知消息
export async function getNoticeList (params) {
  let data = await request.post('/chat/systemsMessage/querySystemsMessagePage', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取通知消息异常'})
  }
}
// 更改消息已读
export async function updateAllNoticeReaded (params) {
  let data = await request.post('/chat/systemsMessage/updateSystemsMessageAlreadyRead', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '更新消息已读异常'})
  }
}
// 更新单个已读消息
export async function updateSingleNoticeReaded (params) {
  let data = await request.post('/chat/systemsMessage/updateSystemsMessageReadByUuid', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '更新消息已读异常'})
  }
}
// 获取图片的base64数据
export async function getImageBase64Code (url) {
  let data = await request.getBase64Image(url)
  if (data) return data
}
// 下载文件
export async function downLoadFile (url, fileName = new Date().valueOf()) {
  await request.downLoad(url, fileName)
}
// 重新获取token
export async function refreshToken (params) {
  let data = await request.post('/uac/aut/refreshToken', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '更新消息已读异常'})
  }
}

export async function genCodeImage () {
  let data = await request.get('/uac/aut/gen', {})
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取验证码异常'})
  }
}
export async function checkCode (params) {
  let data = await request.postJson(`/uac/aut/check?id=${params.id}&mobile=${params.mobile}`, params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '验证码校验异常'})
  }
}

export async function findCheckRateByPage (params) {
  let data = await request.postJson(`/uac/userRate/findCheckRateByPage`, params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '获取评价列表异常') 
}

export async function downLoadRateFile (params) {
  const conf = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Accept': 'application/json'
    }
  }
  await request.downLoad(getApiUrl() + '/uac/userRate/download', '检查评价.xlsx', 'post', params, conf)
}
